
import WDOptionList from './wd-option-list';
import WDCheckButton from '../button/wd-check-button';
import { WDProxyArray } from '../../core/wd-proxy';
import WDUtil from '../../core/wd-util';

export default class WDChecklist extends WDOptionList
{
	#values = [];

	constructor(cfg)
	{
		const baseConfig = {
			options: [],
			multiple: false,
			allow_clear: true,
			separator: ', ',
			templates: {
				label: '${label}',
				value: '${value}'
			}
		};

		WDUtil.merge(baseConfig,cfg);

		super(baseConfig).classList.add('wd-checklist');

		//setup our base proxy for our option storage
		this.#values = new WDProxyArray([]);
		this.#values.on('set', evtData => this.handleValueSet(evtData));
		this.#values.on('delete', evtData => this.handleValueDelete(evtData));
		this.on('item:selected', evt => this.handleItemSelected(evt) );
	
		//
		if (this.config?.value !== undefined) this.value = this.config.value;
	};

	setItemContent(item, data)
	{
		super.setItemContent(item,data);

		item.value = this.config.templates.value.interpolate(data);

		//check it if set
		if (this.#values.includes(item.value))
		{
			item.checked = true;
		}
	};

	createItem()
	{
		//create the new item
		const item = new WDCheckButton();
		item.classList.remove('btn');
		item.classList.add('dropdown-item');

		return item;
	};

	handleValueSet(evtData)
	{
		if (evtData.property == 'length') return;

		this.checkValueRows();
		this.trigger('value:set');
	};

	handleValueDelete(evtData)
	{
		this.checkValueRows();
		this.trigger('value:set');
	};

	checkValueRows()
	{
		const values = this.#values.toArray();

		this.itemArray.forEach(item =>
		{
			item.checked = values.includes(item.value);
		});
	};

	handleItemSelected(evt)
	{
		const { data, item } = evt.detail;

		if (this.config.multiple)
		{
			const idx = this.#values.indexOf(item.value);
			if (idx === -1)
			{
				this.#values.push(item.value);
			} else
			{
				this.#values.splice(idx, 1);
			}
		} 
		else
		{
			const idx = this.#values.indexOf(item.value);
			const shouldClear = this.config.allow_clear && idx !== -1;
			const newVal = shouldClear ? [] : [item.value];
			this.#values.replace(newVal);
		}


		this.trigger('change');
		this.trigger('input'); // not sure we need this one
	};

	get value()
	{
		if (this.config.multiple == true)
		{
			return this.#values;
		}
		else
		{
			return (this.#values.length > 0) ? this.#values[0] : null;
		}
	};

	set value(val)
	{
		if (val === null) val = [];
		else if (!(val instanceof Array)) val = [val];

		this.#values.replace(val);
		this.trigger('value:set');
	};

	set valueLabel(lbls)
	{
		lbls = Array.isArray(lbls) ? lbls : [lbls];

		const setValuesFromLabels = () =>
		{
			const vals = this.options
				.filter(opt => lbls.includes(opt.label))
				.map(opt => opt.value);
			if (vals.length > 0) this.value = vals;
		};

		return new Promise(resolve =>
		{
			if (this.options.length > 0)
			{
				setValuesFromLabels();
				resolve(true);
			} else
			{
				this.one('options:set', () =>
				{
					setValuesFromLabels();
					resolve(true);
				});
			}
		});
	}

	/**
	 * Generates a label based on all the selected values in the list
	 */
	get valueLabel()
	{
		const labels = this.#values
			.map(v =>
			{
				const opt = this.options.find(opt => String(opt.value) === String(v));
				return opt ? opt.label : null;
			})
			.filter(label => label !== null);

		if (labels.length === 0) return null;

		if (typeof labels[0] === 'object')
		{
			const container = wdc('<div/>');
			labels.forEach(label => container.append(label.cloneNode(true)));
			return container;
		}
		return labels.join(this.config.separator);
	}

};

customElements.define('wd-checklist', WDChecklist);
